export class CompleteApptModel {
    appointment_id: number;
    client_no: number;
    appointment_date: string;
    dropoff_time: string;
    dropoff_time_needed: number;
    // public int dropoff_time_needed { get; set; } 
    pickup_time: string;
    // public int pickup_time_needed { get; set; } 
    doctor: string;
    // public string doctor_start_time { get; set; } 
    doctor_time_needed: number; 
    //room: string;
    // public string room_start_time { get; set; } 
    // public int room_time_needed { get; set; } 
    appointment_note: string;
    dropoff: boolean;
    made_by: string;
    modified_by: string;
    create_date: string;
    appt_fulfill: string;
    unscheduled: boolean;
    clinic_no: number;

    constructor(
        appointment_id: number,
        client_no: number,
        appointment_date: string,
        dropoff_time: string,
        dropoff_time_needed: number,
        pickup_time: string,
        // pickup_time_needed: number,
        doctor: string,
        // doctor_start_time: string,
        doctor_time_needed: number,
        //room: string,
        // room_start_time: string,
        // room_time_needed: number,
        appointment_note: string,
        dropoff: boolean,
        made_by: string,
        modified_by: string,
        create_date: string,
        appt_fulfill: string,
        unscheduled: boolean,
        clinic_no: number
    ) {
        this.appointment_id = appointment_id;
        this.client_no = client_no;
        this.appointment_date = appointment_date;
        this.dropoff_time = dropoff_time;
        this.dropoff_time_needed = dropoff_time_needed;
        this.pickup_time = pickup_time;
        // this.pickup_time_needed = pickup_time_needed;
        this.doctor = doctor;
        // this.doctor_start_time = doctor_start_time;
        this.doctor_time_needed = doctor_time_needed;
        //this.room = room;
        // this.room_start_time = room_start_time;
        // this.room_time_needed = room_time_needed;
        this.appointment_note = appointment_note;
        this.dropoff = dropoff;
        this.made_by = made_by;
        this.modified_by = modified_by;
        this.create_date = create_date;
        this.appt_fulfill = appt_fulfill;
        this.unscheduled = unscheduled;
        this.clinic_no = clinic_no;

    }
}




export class CompleteApptSubModel {
    sub_appt_id: number;
    appointment_id: number;
    appointment_date: string;
    pet_no: number;
    pet_name: string;
    appt_proc_id: number;
    dtime: number; // Represented as string for simplicity
    //rtime: string; // Represented as string for simplicity
    //resource: string;
    code1: string;
    code2: string;
    code3: string;
    code4: string;
    status: string;
    //code4: string;
    //code5: string;

    constructor(
        sub_appt_id: number,
        appointment_id: number,
        appointment_date: string,
        pet_no: number,
        pet_name: string,
        appt_proc_id: number,
        dtime: number,
        //rtime: string,
        //resource: string,
        code1: string,
        code2: string,
        code3: string,
        code4: string,
        status: string,
        //code4: string,
        //code5: string
    ) {
        this.sub_appt_id = sub_appt_id;
        this.appointment_id = appointment_id;
        this.appointment_date = appointment_date;
        this.pet_no = pet_no;
        this.pet_name = pet_name;
        this.appt_proc_id = appt_proc_id;
        this.dtime = dtime;
        //this.rtime = rtime;
        //this.resource = resource;
        this.code1 = code1;
        this.code2 = code2;
        this.code3 = code3; 
        this.code4 = code4;
        this.status = status;
        //this.code4 = code4;
        //this.code5 = code5;
    }
}
